import type { OrusSession } from '@orus.eu/backend'
import { isSuccess } from '@orus.eu/result'

import { createLoginRedirect } from './build-login-href.ts'
import { resetLoginBounce } from './detect-login-redirect-loop.ts'
import { readSessionForGuard } from './read-session-for-guard.ts'
import type { SessionGuardOptions } from './session-access.ts'

export async function requireCustomerSession({ context, location, preload }: SessionGuardOptions): Promise<void> {
  const sessionResult = await readSessionForGuard({ context, preload }, isCustomerSession)

  if (!isSuccess(sessionResult)) return

  if (!isCustomerSession(sessionResult.output)) {
    throw createLoginRedirect(location.href, preload)
  }

  if (!preload) {
    resetLoginBounce()
  }
}

function isCustomerSession(session: OrusSession): boolean {
  return session.user !== null && session.permissions.type === 'client'
}
